import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import ScreenDisplayer, { ScreenDisplayerListener} from './box-utils/ScreenDisplayer.react.js';
import {getViewFragment, getDataSourceFragment} from './box-utils/ScreenFragments.react';

import Immutable from 'immutable';
import {RegularPanel, MiniPanel} from './EmbededPanel.react';
import urlMapping from '../app/URLMapping';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import {lastPanelController} from './EmbededPanelController';
import config from '../../common/config';
import EventTracker from '../app/EventTracker';
import LoadingButton from '../fw/LoadingButton.react';
import IotClient from '../../common/util/IotClient';
import openScreenSettings from './screen-settings/openScreenSettings';
//import Intercom from 'react-intercom';
import * as Permission from "../../common/util/Permission";
import * as BrowserPermission from "../BrowserPermission";
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    configError: {defaultMessage: "This usually means problem in your configuration and not in {product}.", id:"panel.error.explanation.config"},
    authError: {defaultMessage: "This usually means problem in your provided authentication information and not in {product}.", id:"panel.error.explanation.auth"},
    remoteError: {defaultMessage: "This usually means problems in {channel} and not in {product}. Retry your request later.", id:"panel.error.explanation.remote"},
	requestError: {defaultMessage: "This usually mean problem in communication with {product}. Retry your request later.", id:"panel.error.explanation.requestError"},
	"400-general": {id: 'panel.error.400-general.msg', 'defaultMessage': 'Error in fetching data from {channel}.'},
	"500-general": {id: 'panel.error.500-general.msg', 'defaultMessage': 'Internal error in {channel}.'},
    "404": {id: 'panel.error.404.msg', 'defaultMessage': 'Entry was not found.'},
    "403": {id: 'panel.error.403.msg', 'defaultMessage': 'Authentication error.'},
    "1000": {id: 'panel.error.1000.msg', 'defaultMessage': 'Internal error in {product}. Error was logged and we will repair it as soon as possible. Retry the action later.'},
	"400": {id: 'panel.error.400.msg', 'defaultMessage': 'Bad Request'},
	"401": {id: 'panel.error.401.msg', 'defaultMessage': 'Unauthorized'},
	"402": {id: 'panel.error.402.msg', 'defaultMessage': 'Payment Required'},
	"405": {id: 'panel.error.405.msg', 'defaultMessage': 'Method Not Allowed'},
	"406": {id: 'panel.error.406.msg', 'defaultMessage': 'Not Acceptable'},
	"407": {id: 'panel.error.407.msg', 'defaultMessage': 'Proxy Authentication Required'},
	"408": {id: 'panel.error.408.msg', 'defaultMessage': 'Request Timeout'},
	"409": {id: 'panel.error.409.msg', 'defaultMessage': 'Conflict'},
	"410": {id: 'panel.error.410.msg', 'defaultMessage': 'Gone'},
	"411": {id: 'panel.error.411.msg', 'defaultMessage': 'Length Required'},
	"412": {id: 'panel.error.412.msg', 'defaultMessage': 'Precondition Failed'},
	"413": {id: 'panel.error.413.msg', 'defaultMessage': 'Payload Too Large'},
	"414": {id: 'panel.error.414.msg', 'defaultMessage': 'URI Too Long'},
	"415": {id: 'panel.error.415.msg', 'defaultMessage': 'Unsupported Media Type'},
	"416": {id: 'panel.error.416.msg', 'defaultMessage': 'Range Not Satisfiable'},
	"417": {id: 'panel.error.417.msg', 'defaultMessage': 'Expectation Failed'},
	"418": {id: 'panel.error.418.msg', 'defaultMessage': 'I\'m a teapot'},
	"422": {id: 'panel.error.422.msg', 'defaultMessage': 'Unprocessable Entity'},
	"423": {id: 'panel.error.423.msg', 'defaultMessage': 'Locked'},
	"424": {id: 'panel.error.424.msg', 'defaultMessage': 'Failed Dependency'},
	"425": {id: 'panel.error.425.msg', 'defaultMessage': 'Unordered Collection'},
	"426": {id: 'panel.error.426.msg', 'defaultMessage': 'Upgrade Required'},
	"428": {id: 'panel.error.428.msg', 'defaultMessage': 'Precondition Required'},
	"429": {id: 'panel.error.429.msg', 'defaultMessage': 'Too Many Requests'},
	"431": {id: 'panel.error.431.msg', 'defaultMessage': 'Request Header Fields Too Large'},
	"451": {id: 'panel.error.451.msg', 'defaultMessage': 'Unavailable For Legal Reasons'},
	"500": {id: 'panel.error.500-r.msg', 'defaultMessage': 'Internal Server Error'},
	"501": {id: 'panel.error.501.msg', 'defaultMessage': 'Not Implemented'},
	"502": {id: 'panel.error.502.msg', 'defaultMessage': 'Bad Gateway'},
	"503": {id: 'panel.error.503.msg', 'defaultMessage': 'Service Unavailable'},
	"504": {id: 'panel.error.504.msg', 'defaultMessage': 'Gateway Timeout'},
	"505": {id: 'panel.error.505.msg', 'defaultMessage': 'HTTP Version Not Supported'},
	"506": {id: 'panel.error.506.msg', 'defaultMessage': 'Variant Also Negotiates'},
	"507": {id: 'panel.error.507.msg', 'defaultMessage': 'Insufficient Storage'},
	"508": {id: 'panel.error.508.msg', 'defaultMessage': 'Loop Detected'},
	"509": {id: 'panel.error.509.msg', 'defaultMessage': 'Bandwidth Limit Exceeded'},
	"510": {id: 'panel.error.510.msg', 'defaultMessage': 'Not Extended'},
	"511": {id: 'panel.error.511.msg', 'defaultMessage': 'Network Authentication Required'},
});

interface PanelProps {
    children?: React.ReactNode;
    data?: string;
    intl: IntlShape;
    relay: object;
    user: User;
}

class Panel extends React.Component<PanelProps> {

    static propTypes = {
        children: PropTypes.node,
        data: PropTypes.string,
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    static contextTypes = {
        embededPanelController: PropTypes.object,
        router: PropTypes.object,
    };

    constructor(props) {
        super(props);

        this.componentWillReceiveProps(props);

        EventTracker.initEventTracker(props.user);

		IotClient.setConfig(this.props.user.iotTopic);
    }

    componentWillReceiveProps(props) {
        if (props.user && props.user.organisation && props.user.organisation.channel && props.user.organisation.channel.screen) {
            this.content = Immutable.fromJS(props.user.organisation.channel.screen.content);
        } else {
            this.content = {};
        }
    }

    config = () => {
        lastPanelController().cancelMinimizePanel();

        let path = urlMapping.getUrl("panel", "screen-settings", lastPanelController().getURLObject());
		openScreenSettings(this.context.router, path);
    };

    restore = () => {
        lastPanelController().cancelMinimizePanel();

        let path = urlMapping.getUrl("panel", "panel", lastPanelController().getURLObject());
        console.log("Development Panel URL", {path: path});  // eslint-disable-line no-console
        this.context.router.push(path);
    };

	linkToAppAuthentication(data) {
		let appUrl = urlMapping.getUrl('channels', "view", {id: data.channel_id, organisation_id: data.organisation_id});

		return (
			<RegularPanel config={BrowserPermission.hasOrganisationPermission(Permission.PERM_EDIT_SCREEN, this.props.user.organisation ? this.props.user.organisation.realId : null) ? this.config : null} typeForTest="panel-error">
				<div className="embedLoading panel-request-error errorContentHttpStatus">
					<div className="">
						<i aria-hidden="true" className="fa fa-exclamation-triangle fa-3x fa-fw margin-bottom panel-request-error-icon" style={{color: 'red'}}></i></div>
					<div className="">
						<div className="panel-request-error-title"><strong><FormattedMessage defaultMessage="Authentication error for {channel}" id="panel.authError.title" values={{'channel': this.props.user.organisation.channel.channelDef.name}}/></strong></div>
						<a className="btn btn-default" href={config.PUBLIC_APP_URL + appUrl + '#authError'} target="_blank"><span className="fa fa-wrench"/>{" "}
							<FormattedMessage defaultMessage="View settings" id="panel.authError.link" />
						</a>
					</div>
				</div>
			</RegularPanel>
		);
	}


    render() {
		let controller = lastPanelController();
        if (controller) {
            let data = controller.getURLObject();
			let user = this.props.user;
			let intl = this.props.intl;

            if (data['error']) {
                let msg;

				switch (data['errorType']) {
					case 401:
						if (data.channelDef_id === user.organisation.channel.channelDef.realId) {
							return this.linkToAppAuthentication(data);
						}
						break;
					case 403:
						msg = intl.formatMessage(messages['403']) + " " + intl.formatMessage(messages.authError, {'product': config.PRODUCT_NAME});
						break;
					case 404:
						msg = intl.formatMessage(messages['404']) + " " + intl.formatMessage(messages.configError, {'product': config.PRODUCT_NAME});
						break;
					default:
						if (data['errorType'] >= 1000) {
							msg = intl.formatMessage(messages['1000'], {'product': config.PRODUCT_NAME});
						}
						else if (data['errorType'] >= 500) {
							let remoteError = intl.formatMessage(messages.remoteError, {'product': config.PRODUCT_NAME, 'channel': user.organisation.channel.channelDef.name});
							msg = intl.formatMessage(messages['500-general'], {'channel': user.organisation.channel.channelDef.name}) + " " + remoteError;
						}
						else  if (data['errorType'] >= 400) {
							let requestError = intl.formatMessage(messages.requestError, {'product': config.PRODUCT_NAME});
							msg = intl.formatMessage(messages['400-general'], {'channel': user.organisation.channel.channelDef.name}) + " " + requestError;
						}
						break;
				}

				let technicalStatus = '';
				if (messages[data['errorType']]) {
					technicalStatus = intl.formatMessage(messages[data['errorType']]);
				}

                return (
                    <RegularPanel config={this.config} typeForTest="panel-error">
                        <div className="embedLoading panel-request-error errorContentHttpStatus">
                            <div className="">
                                <i aria-hidden="true" className="fa fa-exclamation-triangle fa-3x fa-fw margin-bottom panel-request-error-icon"
                                   style={{color: 'red'}}></i></div>
                            <div className="errorContent">
                                <div className="panel-request-error-title"><strong><FormattedMessage defaultMessage="Error fetching data from {channel}" id="panel.error.title" values={{'channel': user.organisation.channel.channelDef.name}}/></strong></div>
                                <div className="panel-request-error-reason">{msg}</div>
                                <div className="panel-request-error-technical"><FormattedMessage defaultMessage="Technical" id="panel.error.techical" />: <code>{data['errorType']} {data['errorMessage'] || technicalStatus}</code></div>
                            </div>
                        </div>
                    </RegularPanel>
                );
            }
        }

        if (controller.isMinimizedPanel()) {
            return (
                <MiniPanel
                    config={this.config}
                    restore={this.restore}
                    typeForTest="panel"
                />
            );
        } else if (this.props.user.organisation && this.props.user.organisation.channel.screen && this.props.user.organisation.channel.screen.viewsWithData && this.props.user.organisation.channel.screen.viewsWithData.edges && this.props.user.organisation.channel.screen.viewsWithData.edges.length > 0) {
            return (
                <RegularPanel config={this.config} typeForTest="panel">
                    <div className="content">
                        <ScreenDisplayer content={this.content}
                                         listener={new ScreenDisplayerListener()}
                                         relay={this.props.relay}
                                         viewsWithData={this.props.user.organisation.channel.screen.viewsWithData.edges.map(({node: viewWithData}) => {
                                             if (!viewWithData.view) {
                                                 return ({});
                                             }
                                             let view = this.props.user.organisation.channel.screen.views.find((view) => viewWithData.view['realId'] === view['realId']);
                                             let dataSource;

                                              if (view) {
                                                  dataSource = this.props.user.organisation.channel.screen.dataSources.find((dataSource) => view['dataSource_id'] === dataSource['realId']);
                                              } else {
                                                  console.log("Missing view", viewWithData.view['realId']); // eslint-disable-line no-console
                                              }

                                             return ({
                                                ...viewWithData,
                                                view: view,
                                                entityDef: dataSource ? dataSource['primaryEntityDef'] : null,
												dataSource: dataSource,
                                             });
                                         })}/>

                        {/*config.isProduction ? <Intercom appID={config.INTERCOM_APP_ID} hide_default_launcher language_override={getLocale()} /> : null*/}
                    </div>
                </RegularPanel>
            );
        } else {
            return (
                <MiniPanel config={this.config} typeForTest="panel-error">
                    <div className="bordered-content">
                        <div className="embedLoading">
                            <div>
                                <FormattedMessage defaultMessage="Screen is empty." id="screenSettings.emptyScreen.description"/>{" "}&nbsp;{" "}<LoadingButton className="btn btn-default" onClick={this.config}><span className="fa fa-cog" />{" "}<FormattedMessage defaultMessage="Configure screen" id="panel.emptyScreen.configure"/></LoadingButton>
                            </div>
                        </div>
                    </div>
                </MiniPanel>
            );
        }
    }
}

export default Relay.createContainer(injectIntl(Panel), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        screenId: '',
        data: null,
        hasData: false,
        hasScreen: false,
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        if (variables.data) {
            if (typeof variables.data !== "string") {
                variables.data = JSON.stringify(variables.data);
            }
            variables.hasData = true;
        } else {
            variables.hasData = false;
        }

        if (variables.screenId) {
            variables.hasScreen = true;
        } else {
            variables.hasScreen = false;
        }

        return variables;
    },
    fragments: {
        user: () => {
            return Relay.QL`
                fragment on User {
                    id,
                    realId,
                    ${EventTracker.getFragment()},
					iotTopic,
                    organisation(id: $organisationId) @include(if: $hasData) {
                        id,
                        realId,
                        channel(id: $channelId) {
                            id,
                            name,
                            channelDef {
                                id,
								realId,
                                name
                            },
                            screen(id: $screenId) @include(if: $hasScreen) {
                                id,
                                realId,
                                content,
                                views {
                                    ${getViewFragment()}
                                },
                                dataSources {
                                    ${getDataSourceFragment()},
									mappedFields {
										id,
										realId,
										name,
										name_l {
											locale,
											content
										},
										shortName,
										shortName_l {
											locale,
											content
										},
										key,
										type,
										exampleData,
									}
                                },
                                viewsWithData(first: 100, data: $data) {
                                    edges {
                                        node {
                                            id,
                                            realId,
                                            view {
                                                id,
                                                realId,
                                            },
                                            data,
                                            addon,
                                            screen {
                                                id,
                                                realId,
                                                channel {
                                                    id,
                                                    realId,
                                                    organisation_id,
                                                }
                                            },
                                            parentEmpty,
                                            parentError,
                                            invalidQuery,
                                            cachingRequired,
                                            cachingRequiredChannels {
                                                id,
                                                organisation_id,
                                                realId,
                                                name,
                                                confidential,
                                                channelDef {
                                                    id,
                                                    realId,
                                                    name,
                                                    icon
                                                }
                                            },
                                            error,
                                            errorDescription,
                                            errorType
                                        }
                                    }
                                }
                            }
                        }
                    }
                }`;
        }
    },


});
